var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 37,
    viewBox: "0 0 32 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7447 0.151597C15.9021 0.0581492 16.0979 0.058142 16.2553 0.151579L31.7553 9.35471C31.907 9.4448 32 9.60819 32 9.78464V28.2155C32 28.3919 31.907 28.5553 31.7553 28.6454L18.4395 36.5516C18.1062 36.7495 17.6842 36.5093 17.6842 36.1216V18.2881C17.6842 18.1116 17.5912 17.9482 17.4394 17.8581L2.40499 8.93326C2.07866 8.73954 2.07862 8.26717 2.40492 8.0734L15.7447 0.151597ZM0.755267 11.9452C0.421971 11.7473 0 11.9875 0 12.3751V28.2155C0 28.3919 0.0930073 28.5553 0.244732 28.6454L13.5605 36.5516C13.8938 36.7495 14.3158 36.5093 14.3158 36.1216V20.2813C14.3158 20.1049 14.2228 19.9415 14.0711 19.8514L0.755267 11.9452Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxIcon);
export default __webpack_public_path__ + "static/media/BoxIcon.e9ce09c3ffb7059f978be6decbe1a6db.svg";
export { ForwardRef as ReactComponent };